import { render } from "./ClientDetailInsightComponent.vue?vue&type=template&id=2d001f4e&scoped=true"
import script from "./ClientDetailInsightComponent.vue?vue&type=script&lang=js"
export * from "./ClientDetailInsightComponent.vue?vue&type=script&lang=js"

import "./ClientDetailInsightComponent.vue?vue&type=style&index=0&id=2d001f4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d001f4e"]])

export default __exports__